import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SiteContentContext = createContext({});

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState({});

  useEffect(() => {
    api.get("/site-content").then(({ data }) => setContent(data)).catch(() => {});
  }, []);

  return <SiteContentContext.Provider value={content}>{children}</SiteContentContext.Provider>;
}

export function useSiteContent() {
  return useContext(SiteContentContext);
}
